import { setItem, getItem } from '../../helpers/localStorage';

export const setPreviousSettings = (accountId: string, settings: any) => {
    setItem(`virtualTerminal_previousSettings_${accountId}`, JSON.stringify(settings));
};

export const getPreviousSettings = (accountId: string): any => {
    try {
        const item = [
            `virtualTerminal_previousSettings_${accountId}`,
            `virtualTerminalv2_previousSettings_${accountId}`,
        ].reduce<any>((acc, key) => acc || getItem(key), null);
        if (!item) {
            return undefined;
        }
        return JSON.parse(item);
    }   catch (e) {
        return undefined;
    }
};
